<template>
  <v-container fluid v-if="user">
    <!-- FILTROS -->
    <v-card outlined elevation="2">
      <v-card-title class="primary white--text">
        Localización en Tiempo Real
      </v-card-title>

      <v-card-text>
        <v-row class="mt-4">
          <v-col cols="12" md="3">
            <v-select
              :items="usuarios.map((u) => u.nombre)"
              label="Seleccionar Usuario"
              v-model="usuarioSelected"
              dense
              outlined
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-combobox
              label="Placas"
              v-model="placas"
              :items="usuarios.map((u) => u.gps)"
              dense
              outlined
            />
          </v-col>

          <v-col cols="12" md="3" class="">
            <v-btn
              color="primary"
              block
              large
              @click="obtenerCoordenadasVehiculo()"
              :loading="loading"
            >
              BUSCAR
            </v-btn>
          </v-col>
          <v-col cols="12" md="3" v-if="intervalId">
            <v-btn color="error" block large @click="stopUpdate()">
              DETENER ACTUALIZACIÓN
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- MAPA -->
    <v-card class="mt-6" height="500" outlined elevation="2">
      <gmap-map
        :center="mapCenter"
        :zoom="zoom"
        style="width: 100%; height: 500px"
        :options="{ gestureHandling: 'greedy' }"
      >
        <!-- MARCADOR -->
        <gmap-marker
          v-if="vehicle"
          :position="markerPosition"
          :icon="carIcon"
          @click="infoWindowOpen = true"
        />

        <!-- INFO WINDOW -->
        <gmap-info-window
          v-if="vehicle"
          :position="markerPosition"
          :opened="infoWindowOpen"
          @closeclick="infoWindowOpen = false"
        >
          <div class="info-window">
            <div class="d-flex justify-space-between mb-2">
              <div>
                <b>Nombre: {{ this.nombre }}</b>
                <div>
                  <b>Comentario: {{ this.comentario }}</b>
                </div>
                <div class="caption">PLACA: {{ this.placas }}</div>
              </div>
              <v-chip
                x-small
                :color="vehicle.speed === '0' ? 'red' : 'green'"
                text-color="white"
              >
                {{ vehicle.speed === "0" ? "Detenido" : "En Movimiento" }}
              </v-chip>
            </div>

            <v-divider class="my-2" />

            <div class="caption">
              <v-icon x-small>mdi-car-speed-limiter</v-icon>
              Velocidad: <b>{{ vehicle.speed }} km/h</b>
            </div>
            <!--
            <div class="caption">
              <v-icon x-small>mdi-history</v-icon>
              {{ fecha || "Obteniendo fecha..." }}
            </div>
            -->
            <div class="caption">
              <v-icon x-small>mdi-map-marker</v-icon>
              {{ direccion || "Obteniendo direccion..." }}
            </div>

            <div v-if="tiempoParado" class="caption">
              <v-icon x-small>mdi-timer</v-icon>
              Tiempo parado:
              {{ tiempoParadoFormateado + "," + " Desde: " + fechaFormateada }}
            </div>

            <div class="caption d-flex justify-center mt-2">
              <v-btn x-small color="primary" @click="abrirGoogleMaps"
                >Abrir en Google Maps</v-btn
              >
            </div>
          </div>
        </gmap-info-window>

        <!-- POLILÍNEA PARA HISTORIAL 
        <gmap-polyline
          v-if="vehicles.length > 1"
          :path="path"
          :options="{
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
          }"
        />
        -->
      </gmap-map>
    </v-card>

    <!-- KPIS 
    <v-row class="mt-6">
      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 d-flex">
          <v-icon color="blue" large class="mr-4">trending_up</v-icon>
          <div>
            <div class="caption">Distancia Total Hoy</div>
            <div class="headline">1,248.5 km</div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 d-flex">
          <v-icon color="orange" large class="mr-4">local_gas_station</v-icon>
          <div>
            <div class="caption">Consumo Combustible</div>
            <div class="headline">342.2 L</div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 d-flex">
          <v-icon color="primary" large class="mr-4">schedule</v-icon>
          <div>
            <div class="caption">Tiempo en Ralentí</div>
            <div class="headline">4h 12m</div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    -->
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Papa from "papaparse";
import pako from "pako";
import carGif from "@/assets/auto2.gif";
import moment from "moment";

export default {
  data() {
    return {
      mapCenter: { lat: 32.62340014186072, lng: -115.46240380788693 },
      zoom: 12,
      vehicle: null, // datos del endpoint
      vehicles: [], // todos los datos
      infoWindowOpen: false,
      placas: null,
      direccion: "",
      fecha: "",
      tiempoParado: null, // tiempo que ha estado parado
      nombre: "",
      comentario: "",
      intervalId: null, // para actualización en tiempo real
      timeoutId: null, // para parar después de 5 minutos
      usuarios: [],
      usuarioSelected: null,
      loading: false,
    };
  },
  methods: {
    async obtenerCoordenadasVehiculo() {
      try {
        this.loading = true;
        const response = await axios.get(
          `/gps/get_localizacion_actual?placas=${this.placas}`,
          {
            responseType: "arraybuffer",
          }
        );
        //sacar el nombre de la respuesta del header
        this.nombre = response.headers["x-nombre"];
        this.comentario = response.headers["x-comentario"];

        // Descomprimir el gzip
        const decompressed = pako.ungzip(response.data, { to: "string" });
        // Parsear el CSV
        const parsed = Papa.parse(decompressed, {
          header: true, // Si la primera fila son headers
          skipEmptyLines: true,
        });
        // parsed.data será un array de objetos
        this.vehicles = parsed.data.sort(
          (a, b) => new Date(a.dateTime) - new Date(b.dateTime)
        ); // Ordenar por fecha ascendente

        // Seleccionar el vehículo más reciente (el último de la lista ordenada)
        this.vehicle = this.vehicles[this.vehicles.length - 1];

        // Calcular tiempo parado si speed es 0
        this.tiempoParado = null;
        if (parseFloat(this.vehicle.speed) === 0) {
          for (let i = this.vehicles.length - 2; i >= 0; i--) {
            if (parseFloat(this.vehicles[i].speed) !== 0) {
              const start = moment(Number(this.vehicles[i].dateTime));
              const end = moment(Number(this.vehicle.dateTime));
              const duration = moment.duration(end.diff(start));
              this.tiempoParado = {
                minutos: Math.floor(duration.asMinutes()),
                horas: Math.floor(duration.asHours()),
                dias: Math.floor(duration.asDays()),
              };
              break;
            }
          }
        }

        //console.log("Datos del vehículo seleccionado:", this.vehicle);
        //console.log("Todos los datos:", this.vehicles);

        this.direccion = await this.ObtenerDireccion(
          this.vehicle.latitude,
          this.vehicle.longitude
        );

        this.fecha = this.formatearFecha(this.vehicle.dateTime);
        this.mapCenter = {
          lat: Number(this.vehicle.latitude),
          lng: Number(this.vehicle.longitude),
        };
        this.zoom = 16;
        this.infoWindowOpen = true;

        /* Iniciar actualización en tiempo real cada segundo
        if (!this.intervalId) {
          this.intervalId = setInterval(() => {
            this.obtenerCoordenadasVehiculo();
          }, 10000); // cada 10 segundos

          // Iniciar timeout para parar después de 5 minutos
          this.timeoutId = setTimeout(() => {
            this.stopUpdate();
            const continuar = confirm(
              "¿Aún estás ahí? ¿Quieres continuar la actualización del GPS?"
            );
            if (continuar) {
              this.obtenerCoordenadasVehiculo();
            }
          }, 300000); // 5 minutos
        }*/

        this.loading = false;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          alert("No se encontraron datos para las placas proporcionadas.");
        } else {
          alert(
            "Ocurrió un error al obtener las coordenadas del vehículo. Por favor, inténtalo de nuevo."
          );
        }
        this.loading = false;
        console.error("Error al obtener las coordenadas del vehículo:", error);
      }
    },
    async ObtenerDireccion(lat, lng) {
      await this.$gmapApiPromiseLazy();

      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              resolve(results[0].formatted_address);
            } else {
              resolve("No se encontraron resultados");
            }
          } else {
            reject("Error en la geocodificación: " + status);
          }
        });
      });
    },

    abrirGoogleMaps() {
      if (this.direccion) {
        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          this.direccion
        )}`;
        window.open(url, "_blank");
      }
    },

    formatearFecha(fecha) {
      const dateTime = moment(Number(fecha)).format("DD/MM/YYYY ");
      return dateTime;
    },
    stopUpdate() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        console.log("Actualización en tiempo real detenida");
      }
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    async getUsuarios() {
      try {
        const usuarios = await axios.get("/usuarios/get_usuarios");
        //filtrar a los usuarios solo con gps
        this.usuarios = usuarios.data.usuarios.filter(
          (usuario) => usuario.gps !== null && usuario.gps !== ""
        );
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    markerPosition() {
      if (!this.vehicle) return null;
      return {
        lat: Number(this.vehicle.latitude),
        lng: Number(this.vehicle.longitude),
      };
    },

    carIcon() {
      return {
        url: carGif,
        scaledSize: { width: 50, height: 50 },
        anchor: { x: 20, y: 20 },
      };
    },

    path() {
      return this.vehicles.map((v) => ({
        lat: Number(v.latitude),
        lng: Number(v.longitude),
      }));
    },

    tiempoParadoFormateado() {
      if (!this.tiempoParado) return "";
      const duration = moment.duration(this.tiempoParado.minutos, "minutes");
      const days = Math.floor(duration.asDays());
      const hours = Math.floor(duration.asHours()) % 24;
      const minutes = Math.floor(duration.asMinutes()) % 60;
      let str = "";
      if (days > 0) str += `${days} días `;
      if (hours > 0) str += `${hours} horas `;
      if (minutes > 0 || str === "") str += `${minutes} minutos`;
      return str.trim();
    },

    fechaFormateada() {
      if (!this.tiempoParado) return "";
      const fecha = moment.duration(this.tiempoParado.minutos, "minutes");
      let fechaFinal = moment(fecha).format("DD/MM/YYYY");
      return fechaFinal;
    },
  },

  created() {
    this.getUsuarios();
  },
  watch: {
    usuarioSelected(newVal) {
      const usuario = this.usuarios.find((u) => u.nombre === newVal);
      if (usuario) {
        this.placas = usuario.gps;
      }
    },
    placas(newVal) {
      const usuario = this.usuarios.find((u) => u.gps === newVal);
      if (usuario) {
        this.usuarioSelected = usuario.nombre;
      }
    },
  },
};
</script>

<style scoped>
.map-pin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  background: #00bfa5;
  border-radius: 50%;
  padding: 10px;
}

.map-info {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
  width: 260px;
}
</style>
